var dsox = dsox || {};
dsox.InteractiveGraphic = (function () {
    
    var fadeAndShow = function ($) {
        $(document)
            .on('click', '.js-nested-link', function(e){
                e.preventDefault();
                
                $('.js-top-headline').removeClass('active');
                $('.js-top-graphic').removeClass('active');
                $('.js-nested-graphic').removeClass('active');

                $('.js-nested-headline').addClass('active');

                var parent = $('.top-graphic-map');
                var container = $(this).data('link');
                $("#"+container).addClass('active');

                $("#"+container+'-map').fadeIn("slow");
                
                switch(container) {
                    case "airport":
                        parent.addClass('top-right').fadeOut("slow");
                        break;
                    case "downtown":
                        parent.addClass('bottom-center').fadeOut("slow");
                        break;
                    case "entertainmentdistrict":
                        parent.addClass('top-left').fadeOut("slow");
                        break;
                    case "industrialpark":
                        parent.addClass('bottom-right').fadeOut("slow");
                        break;
                    case "schoolcampus":
                        parent.addClass('bottom-left').fadeOut("slow");
                        break;
                    case "technologypark":
                        parent.addClass('top-center').fadeOut("slow");
                        break;
                    default:
                        parent.addClass('top-center').fadeOut("slow");
                        break;
                }

                $('img[usemap]').rwdImageMaps();
            })
            .on('click', '.js-top-link', function(e){
                e.preventDefault();

                $('.js-top-headline').addClass('active');
                $('.js-top-graphic').addClass('active');
                
                $('.js-nested-headline').removeClass('active');
                $('.js-nested-graphic').removeClass('active');

                $('.top-graphic-map').removeClass('top-left top-center top-right bottom-left bottom-center bottom-right').show();

                $('.nested-graphic-maps').hide();

                $('img[usemap]').rwdImageMaps();
                
            })
            .on('click', '.top-graphic-map map area', function(e){
                e.preventDefault();
                
                var parent = $('.top-graphic-map');
                var imageID = $(this).attr('title').replace(" ", "").toLowerCase();

                $('.js-top-headline').removeClass('active');
                $('.js-top-graphic').removeClass('active');
                $('.js-nested-graphic').removeClass('active');

                $('.js-nested-headline').addClass('active');

                $("#"+imageID).addClass('active');
                
                $("#"+imageID+'-map').fadeIn("slow");
                
                switch(imageID) {
                    case "airport":
                        parent.addClass('top-right').fadeOut("slow");
                        break;
                    case "downtown":
                        parent.addClass('bottom-center').fadeOut("slow");
                        break;
                    case "entertainmentdistrict":
                        parent.addClass('top-left').fadeOut("slow");
                        break;
                    case "industrialpark":
                        parent.addClass('bottom-right').fadeOut("slow");
                        break;
                    case "schoolcampus":
                        parent.addClass('bottom-left').fadeOut("slow");
                        break;
                    case "technologypark":
                        parent.addClass('top-center').fadeOut("slow");
                        break;
                    default:
                        parent.addClass('top-center');
                        break;
                }

                $('img[usemap]').rwdImageMaps();
            })

        $('img[id*="image-overlay"').each(function(){
            var thisLink = $(this).data('link');
            
            var thisTitle = $(this).data('title');

            $('area[title="'+thisTitle+'"').attr('href', thisLink);
        })
        
        $('.top-graphic-map map area').each(function(){
            var $this = $(this);
            imageMapHover($, $this, true);
        })

        $('.nested-graphic-maps map area').each(function(){
            var $this = $(this);
            imageMapHover($, $this, false);
        })
    }

    var imageMapHover = function ($, $this, top) {
        var imageID = $this.attr('title').replace("-", "").replace(" ", "").toLowerCase();
        imageID += top ? "-top-image-overlay" : "-image-overlay";
            
        $this.mouseover(function() {
            $('#'+imageID).show();
        });
        
        $this.mouseout(function() {
            $('#'+imageID).hide();
        });
    }

    return {
        fadeAndShow: fadeAndShow
    }

}());